import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { markBusinessAsChurnReturn } from 'api/admin/businesses/businesses';
import { ApiError } from 'types/api';

interface MarkBusinessAsChurnReturnPayload {
  successCallback?: () => void;
}

interface BusinessIdPayload {
  businessId: number;
}

interface SuccessResponse {
  success: boolean;
}

export const useMarkBusinessAsChurnReturn = ({ successCallback }: MarkBusinessAsChurnReturnPayload) => {
  return useMutation<unknown, ApiError, BusinessIdPayload>({
    mutationFn: async ({ businessId }) => {
      if (!businessId) {
        return null;
      }

      const { data } = (await markBusinessAsChurnReturn(businessId)) as AxiosResponse<SuccessResponse>;

      return data;
    },
    onSuccess: () => {
      successCallback?.();
      toast('Business successfully marked as live and churn has been revoked', {
        duration: 4000,
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'An error occurred while marking the business as live',
        {
          duration: 4000,
        },
      );
    },
  });
};
